// Overlays rendered into document.body share a stacking context with the sticky
// app header, so anything that may stay open while the page scrolls has to sit
// below it — otherwise it scrolls over the header and covers its content.
export const Z_INDEXES = {
    HEADER: 10,
    STICKY_SUBHEADER: 9,
    TOOLTIP: 9,
    STICKY_FOOTER: 20
};
